<template>
  <page-wrapper :title="title" :has-pad="true">
    <div v-if="user" class="container">
      <div class="row">
        <div class="col-3 detail">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <h4 style="margin-bottom: 0">ข้อมูลทั่วไป</h4>
            <RueJaiChatButton
              :id="userId"
              :is-support-rue-jai-chat="user.isSupportRueJaiChat"
              :small="true"
            />
          </div>
          <hr style="margin-top: 4px" />
          <div
            class="row mx-0 d-flex justify-content-between justify-items-center align-items-center"
          >
            <p>ชื่อ</p>
            <ri-link-button :link="ruejaiIntelligenceLink"></ri-link-button>
          </div>
          <div class="mb-3">{{ user.firstName }}</div>
          <p>นามสกุล</p>
          <div class="mb-3">{{ user.lastName }}</div>
          <p>เพศ</p>
          <div class="mb-3">{{ user.gender }}</div>
          <p>วันเกิด</p>
          <div class="mb-3">{{ user.birthDate }}</div>
          <p>บัตรประชาชน / Passport</p>
          <div class="mb-3">
            <button
              v-if="!isButtonHidden"
              class="button-content"
              @click="handleDecryptIdCard"
            >
              <span style="font-weight: bold">แสดงข้อมูล</span>
              <i class="fa fa-eye-slash" aria-hidden="true"></i>
            </button>
            <div v-if="user.identifierId" class="identifier-id">
              {{ user.identifierId }}
            </div>
          </div>
          <p>เบอร์โทรศัพท์</p>
          <div class="mb-3">
            <div>
              <a
                v-if="user.phoneNumber && user.phoneNumber !== '-'"
                :href="`callto://${user.phoneNumber}`"
                class="callto-link"
              >
                {{ user.phoneNumber }}
              </a>
              <span v-else>-</span>
            </div>
          </div>
          <p>อีเมล</p>
          <div class="mb-3">{{ user.email }}</div>
          <p>สถานะ</p>
          <div class="mb-3">{{ user.status }}</div>
          <p>ช่องทางการสมัคร RueJai App</p>
          <div class="mb-3">{{ user.registrationType }}</div>
          <sc-button
            variant="secondary"
            class="mb-4"
            @click="handleClickChangePhoneNumber"
            >เปลี่ยนเบอร์โทรศัพท์</sc-button
          >
          <sc-button
            variant="secondary"
            class="mb-4"
            @click="handleClickChangeEmail"
            >เปลี่ยนอีเมล</sc-button
          >
          <sc-button
            variant="secondary"
            class="mb-4"
            @click="handleClickChangePassword"
            >เปลี่ยน Password</sc-button
          >
          <sc-button
            v-if="showReverifyButton"
            variant="danger"
            class="mb-4"
            @click="handleClickReverifyButton"
            >ให้ยืนยันตัวตนใหม่</sc-button
          >
          <sc-button
            v-if="showVerifyButton"
            variant="warning"
            class="mb-4"
            @click="handleClickVerifyUser"
            >ยืนยันตัวตนเป็นเจ้าของกรรมสิทธิ์ / ผู้เช่าซื้อบ้าน</sc-button
          >
          <sc-button
            v-if="showVerifyButton"
            variant="amber"
            class="mb-4"
            @click="handleClickVerifyResident"
            >ยืนยันตัวตนเป็น ผู้อยู่อาศัย / ผู้เช่า</sc-button
          >
          <sc-button
            v-if="enableDelete"
            variant="danger"
            @click="handleClickDeleteUser"
            >ลบผู้ใช้</sc-button
          >
          <confirm-dialog
            v-if="deleteUserDialog.isShow"
            :data="deleteUserDialog"
            @confirm="handleConfirmDeleteUser"
          >
            <div class="text-center">
              <el-input
                v-model="confirmDeleteUserEmail"
                placeholder="พิมพ์อีเมลผู้ใช้ที่ต้องการลบ"
              ></el-input>
            </div>
            <p class="text-danger text-center">
              กรุณาตรวจสอบความถูกต้องว่าเป็น
              <strong>ผู้ใช้ที่ต้องการจะลบ</strong>
              <br />หากยืนยันการ <strong>ลบ</strong>ไปแล้ว
              จะไม่สามารถย้อนกลับมาแก้ไขได้อีก
            </p>
            <el-checkbox v-model="isConfirmDeleteUserAgreement">
              <p class="checkboxConfirmMessage">
                ข้าพเจ้า
                <strong>{{ adminFirstName }} {{ adminLastName }}</strong>
                ยอมรับผิดชอบต่อความเสียหายใด ๆ ที่เกิดจากการลบผู้ใช้นี้
              </p>
            </el-checkbox>
            <p class="checkboxConfirmMessage text-center">
              หมายเหตุ - การลบ ‘ผู้ใช้’ มีการบันทึกประวัติการกระทำไว้
            </p>
          </confirm-dialog>
          <confirm-dialog
            v-if="verifyDialog.isShow"
            :data="verifyDialog"
            @confirm="handleConfirmVerifyUser"
          >
            <label class="lable">บัตรประชาชน / Passport</label>
            <el-input v-model="identifierId" class="input" />
          </confirm-dialog>
          <confirm-dialog
            v-if="verifyResidentDialog.isShow"
            :data="verifyResidentDialog"
            @confirm="handleConfirmVerifyResident"
          >
            <label class="lable">บัตรประชาชน / Passport</label>
            <el-input v-model="identifierId" class="input" />
          </confirm-dialog>
        </div>
        <div class="col-9">
          <h4>ข้อมูลบ้าน</h4>
          <hr />
          <div class="text-end">
            <sc-button variant="primary" @click="handleClickAdd"
              >เพิ่มเข้าบ้าน</sc-button
            >
          </div>
          <div v-show="isAdding">
            <add-home v-model="addHomeForm"></add-home>
            <div class="text-end">
              <sc-button class="me-2" @click="handleCancelAdd"
                >ยกเลิก</sc-button
              >
              <sc-button variant="primary" @click="handleSaveAdd"
                >บันทึก</sc-button
              >
            </div>
          </div>
          <div class="bottom-right">
            <sc-button :route="userLogButton.route" variant="primary">{{
              userLogButton.label
            }}</sc-button>
          </div>
          <home-list
            :homes="homes"
            class="mt-4"
            @remove="handleRemove"
          ></home-list>
          <p v-if="homes.length === 0" class="text-center">ไม่มีข้อมูล</p>
        </div>
      </div>
    </div>
    <confirm-dialog
      v-if="confirmDialog.isShow"
      :data="confirmDialog"
      @confirm="handleConfirm"
    >
      <div class="text-center">
        <el-input v-model="newPassword" placeholder="Password ใหม่"></el-input>
      </div>
      <p class="text-danger text-center">
        กรุณาตรวจสอบข้อมูล
        <strong>ลูกบ้าน</strong>ว่าเป็น
        <strong>คนที่ต้องการจะเปลี่ยน Password</strong> ให้ <br />หากกด
        <strong>บันทึก</strong>ไปแล้ว จะไม่สามารถย้อนกลับมาแก้ไขได้อีก
      </p>
    </confirm-dialog>
    <confirm-dialog
      v-if="changeEmailConfirmDialog.isShow"
      :data="changeEmailConfirmDialog"
      @confirm="handleChangeEmailConfirm"
    >
      <div class="text-center">
        <el-input v-model="newEmail" placeholder="อีเมลใหม่"></el-input>
      </div>
    </confirm-dialog>
    <confirm-dialog
      v-if="changePhoneNumberDialog.isShow"
      :data="changePhoneNumberDialog"
      @confirm="handleConfirmPhoneNumber"
    >
      <div class="text-center">
        <el-input
          v-model="newPhoneNumber"
          placeholder="เบอร์โทรศัพท์ใหม่"
        ></el-input>
      </div>
    </confirm-dialog>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient, backendAdminClient } from "@/dependencies"
import PageWrapper from "@/lib/components/PageWrapper"
import RiLinkButton from "@/lib/components/RiLinkButton"
import ScButton from "@/lib/components/ScButton"
import { toLocaleTH } from "@/lib/dateTime"
import { genderMapper, userRole, inverseUserRoleMapper } from "@/lib/mapper"
import { resolveRegistrationTypeName } from "@/lib/util"

import { Checkbox, Input, MessageBox } from "element-ui"
import { DateTime } from "luxon"

import AddHome from "../components/AddHome"
import HomeList from "../components/HomeList"
import RueJaiChatButton from "../components/RueJaiChatButton"

export default {
  components: {
    PageWrapper,
    ScButton,
    AddHome,
    HomeList,
    "el-input": Input,
    "el-checkbox": Checkbox,
    RueJaiChatButton,
    RiLinkButton,
  },
  data() {
    const makeDialog = (title, buttonSubmit = "บันทึก") => ({
      isShow: false,
      title,
      buttonCancel: "ยกเลิก",
      buttonSubmit,
    })

    return {
      title: "ข้อมูลผู้ใช้",
      user: null,
      homes: null,
      addHomeForm: { project: null, homes: [], role: null },
      isAdding: false,
      enableDelete: false,
      changePhoneNumberDialog: makeDialog("เปลี่ยนแปลงเบอร์โทรศัพท์"),
      confirmDialog: makeDialog("เปลี่ยนแปลง Password"),
      changeEmailConfirmDialog: makeDialog("เปลี่ยนแปลงอีเมล"),
      verifyDialog: makeDialog("ยืนยันตัวตนเป็นเจ้าของกรรมสิทธิ์ / ผู้เช่าซื้อบ้าน", "ยืนยัน"),
      verifyResidentDialog: makeDialog("ยืนยันตัวตนเป็น ผู้อยู่อาศัย / ผู้เช่า", "ยืนยัน"),
      deleteUserDialog: makeDialog("ลบผู้ใช้", "ยืนยัน"),
      userLogButton: {
        label: "ดูประวัติการเปลี่ยนแปลง",
        route: { name: "UserLogPage" },
      },
      newEmail: "",
      newPassword: "",
      newPhoneNumber: "",
      identifierId: "",
      confirmDeleteUserEmail: "",
      isConfirmDeleteUserAgreement: false,
      isOwner: true,
      isButtonHidden: false,
    }
  },
  computed: {
    showReverifyButton() {
      return this.user.isVerifiedAsVisitor
    },
    showVerifyButton() {
      return !this.user.isVerified
    },
    adminFirstName() {
      return localStorage.getItem("adminFirstName") ?? ""
    },
    adminLastName() {
      return localStorage.getItem("adminLastName") ?? ""
    },
    userId() {
      const { id } = this.$route.params

      return parseInt(id, 10)
    },
    ruejaiIntelligenceLink() {
      return `${process.env.RUEJAI_INTELLIGENCE_HOST}/ruejai-intelligence/users/${this.userId}`
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      const permission = JSON.parse(localStorage.getItem("adminRolePermission"))
      if (permission.features.find((x) => x.featureId === 28) !== undefined) {
        // enable delete user button
        this.enableDelete = true
      }
      this.setupData()
    },
    async setupData() {
      await this.setupUser()
      this.identifierId = this.user.identifierId
    },
    async setupUser() {
      const data = await this.fetchUser()

      const { user_profile: profile, has_user_verify: hasUserVerify, registration_type: registrationType } = data
      const isVerified = profile.is_verified
      const isVerifiedAsVisitor = isVerified && !hasUserVerify

      const user = {
        email: data.email,
        firstName: profile.first_name,
        lastName: profile.last_name,
        gender: profile.gender
          ? genderMapper[profile.gender.toLowerCase()]
          : "-",
        birthDate: profile.birth_date
          ? toLocaleTH(DateTime.fromISO(profile.birth_date)).toFormat(
              "dd MMMM yyyy",
            )
          : "-",
        identifierId: "",
        phoneNumber: profile.mobile_number || "-",
        status: isVerified ? "ยืนยันตัวตนแล้ว" : "ยังไม่ยืนยันตัวตน",
        isVerified,
        isVerifiedAsVisitor,
        registrationType: resolveRegistrationTypeName(registrationType),
        isSupportRueJaiChat: profile.is_rj_chat_enabled,
      }

      this.user = user
      this.homes = (data.homes || []).map((home) => ({
        id: home.home_id,
        projectId: home.project_id,
        userRole: home.user_role,
        addressNumber: home.address_no,
        projectName: `${home.project_name} (${home.project_code})`,
      }))
    },
    async fetchUser() {
      const response = await baanRueJaiClient.admin.users.get(this.userId)

      return response.data.result
    },
    async inviteUserToHome() {
      const { project, homes, role } = this.addHomeForm
      const homeIds = homes.filter(Boolean).map(({ homeId }) => homeId)
      const { projectId } = project
      const params = {
        homeIds,
        projectId,
        role,
      }

      await baanRueJaiClient.admin.users.invite(this.userId, params)
    },
    async handleClickReverifyButton() {
      try {
        await MessageBox.confirm("ยืนยันการให้ผู้ใช้ไปยืนยันตัวตนใหม่", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        })
      } catch (e) {
        return
      }

      if (!this.user.isVerified) {
        this.$message.error("ผู้ใช้ไม่ได้ยืนยันตัวตนอยู่แล้ว")
        return
      }

      if (!this.user.isVerifiedAsVisitor) {
        this.$message.error(
          "ผู้ใช้ยืนยันตัวตนเป็นเจ้าของกรรมสิทธิ์ / ผู้เช่าซื้อบ้าน หรือ เคยถูกเชิญเข้าบ้านแล้ว",
        )
        return
      }

      await baanRueJaiClient.admin.users.reverify({ userId: this.userId })
      await this.setupData()
    },
    async handleClickAdd() {
      this.isAdding = true
    },
    async handleCancelAdd() {
      this.resetForm()
      this.isAdding = false
    },
    validateAddHomeForm() {
      if (
        this.addHomeForm.project === null ||
        this.addHomeForm.homes.length === 0 ||
        this.addHomeForm.role === null
      ) {
        return false
      }

      return true
    },
    async handleSaveAdd() {
      if (!this.validateAddHomeForm()) {
        this.$message.error("กรุณาเลือกโครงการ บ้าน และสิทธิ์")
        return
      }

      const validRoleForVerifiedUser = [
        userRole.OWNER,
        userRole.RESIDENT,
        userRole.RENTER,
        userRole.RENT_TO_OWN,
      ]

      if (
        !this.user.isVerified &&
        validRoleForVerifiedUser.includes(this.addHomeForm.role)
      ) {
        const message = `ผู้ใช้ยังไม่ยืนยันตัวตน! ต้องการเพิ่ม ${this.user.firstName} ${this.user.lastName} เข้าโครงการ ${this.addHomeForm.project.projectName} ใช่หรือไม่?`

        try {
          await MessageBox.confirm(message, {
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก",
          })
        } catch (e) {
          return
        }
      }

      try {
        await this.inviteUserToHome()
        this.addHomeForm = { homes: [], project: null, role: null }
        this.isAdding = false
        await this.setup()
      } catch (err) {
        this.$message.error(err.response.data.message)
      }
    },
    resetForm() {
      this.addHomeForm = {
        homes: [],
        role: null,
        project: null,
      }
    },
    async handleRemove(home) {
      const message = `ยืนยันการไล่ ${this.user.firstName} ${this.user.lastName} ออกจากบ้านเลขที่ ${home.addressNumber} โครงการ ${home.projectName}`

      try {
        await MessageBox.confirm(message, {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        })
      } catch (e) {
        return
      }

      try {
        await this.uninvite(home)
        await this.setup()
      } catch (err) {
        this.$message.error("ผิดพลาด")
      }
    },
    async uninvite(home) {
      const homeIds = [home.id]
      const role = inverseUserRoleMapper[home.userRole] ?? home.userRole
      const params = { homeIds, role }

      await baanRueJaiClient.admin.users.uninvite(this.userId, params)
    },
    handleClickChangeEmail() {
      this.changeEmailConfirmDialog.isShow = true
    },
    handleClickChangePhoneNumber() {
      this.changePhoneNumberDialog.isShow = true
    },
    handleClickChangePassword() {
      this.confirmDialog.isShow = true
    },
    handleClickVerifyUser() {
      this.isOwner = true
      this.verifyDialog.isShow = true
    },
    handleClickVerifyResident() {
      this.isOwner = false
      this.verifyResidentDialog.isShow = true
    },
    async verify() {
      const baseParams =
        this.identifierId.length === 13
          ? { citizenId: this.identifierId }
          : { passportNumber: this.identifierId }
      const params = { ...baseParams, isOwner: this.isOwner }

      await baanRueJaiClient.admin.users.postVerify(this.userId, params)
    },
    async handleConfirmVerifyUser(isConfirm) {
      await this.confirmVerify(isConfirm, "verifyDialog")
    },
    async handleConfirmVerifyResident(isConfirm) {
      await this.confirmVerify(isConfirm, "verifyResidentDialog")
    },
    async confirmVerify(isConfirm, dialogKey) {
      if (!isConfirm) {
        this[dialogKey].isShow = false
        this.identifierId = this.user.identifierId
        return
      }

      try {
        await this.verify()
        this[dialogKey].isShow = false
        await this.setup()
      } catch (err) {
        this.$message.error(err.response.data.message)
      }
    },
    async handleChangeEmailConfirm(isConfirm) {
      if (!isConfirm) {
        this.changeEmailConfirmDialog.isShow = false
        this.newEmail = ""
        return
      }

      try {
        await baanRueJaiClient.admin.users.putEmail(
          this.userId,
          {
            email: this.newEmail,
          },
        )

        this.newEmail = ""
        this.changeEmailConfirmDialog.isShow = false
        this.$message.success("เปลี่ยนอีเมลเรียบร้อย")

        await this.setup()
      } catch (error) {
        if (error.response.data.errorCode === "EMAIL_ALREADY_USED") {
          this.$message.error(error.response.data.message)
        } else {
          this.$message.error("ไม่สามารถเปลี่ยนอีเมลได้")
        }
      }
    },
    async handleConfirm(isConfirm) {
      if (!isConfirm) {
        this.confirmDialog.isShow = false
        this.newPassword = ""
        return
      }

      try {
        await MessageBox.confirm("ยืนยันการเปลี่ยน Password", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        })
      } catch (e) {
        this.confirmDialog.isShow = false
        this.newPassword = ""
        return
      }

      try {
        await baanRueJaiClient.admin.users.putPassword(
          this.userId,
          {
            password: this.newPassword,
          },
        )

        this.newPassword = ""
        this.confirmDialog.isShow = false
        this.$message.success("เปลี่ยน Password เรียบร้อย")
      } catch (error) {
        this.$message.error("ไม่สามารถเปลี่ยน Password ได้")
      }
    },
    async handleConfirmPhoneNumber(isConfirm) {
      if (!isConfirm) {
        this.changePhoneNumberDialog.isShow = false
        this.newPhoneNumber = ""
        return
      }

      try {
        await baanRueJaiClient.admin.users.putPhoneNumber(
          this.userId,
          {
            mobileNumber: this.newPhoneNumber,
          },
        )

        this.newPhoneNumber = ""
        this.changePhoneNumberDialog.isShow = false
        this.$message.success("เปลี่ยนเบอร์โทรศัพท์เรียบร้อย")

        await this.setup()
      } catch (error) {
        this.$message.error("ไม่สามารถเปลี่ยนเบอร์โทรศัพท์ได้")
      }
    },
    handleClickDeleteUser() {
      this.deleteUserDialog.isShow = true
    },
    async handleConfirmDeleteUser(isConfirm) {
      if (!isConfirm) {
        this.confirmDeleteUserEmail = ""
        this.isConfirmDeleteUserAgreement = false
        this.deleteUserDialog.isShow = false
        return
      }

      if (!this.isConfirmDeleteUserAgreement) {
        this.$message.error("กรุณายอมรับข้อตกลงการลบผู้ใช้")
        return
      }

      if (this.confirmDeleteUserEmail !== this.user.email) {
        this.$message.error("กรุณาพิมพ์อีเมลให้ตรงกับผู้ใช้ที่ต้องการลบ")
        return
      }

      try {
        await baanRueJaiClient.admin.users.deleteUser(
          this.userId,
        )

        this.$message.success("ลบผู้ใช้เรียบร้อย")

        this.$router.push({ name: "UserListPage" })
      } catch (error) {
        this.$message.error("ไม่สามารถลบผู้ใช้ได้")
      }
    },
    async handleDecryptIdCard() {
      try {
        const { userId } = this
        const response =
          await backendAdminClient.user.getDecryptedIdCard(userId)

        this.user.identifierId = response.data.result.id_card
        this.isButtonHidden = true
      } catch (error) {
        this.$message.error("ไม่สามารถเข้าถึงได้")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.detail {
  border-right: $border;
}
.bottom-right {
  right: 0;
  bottom: 0;
  position: absolute;
}

.checkboxConfirmMessage {
  font-size: 15px;
}

.button-content {
  width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  font-size: 16px;
  color: #4a4a4a;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}

.button-content:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.callto-link {
  color: $blue;
  text-decoration: underline;

  &:hover {
    font-weight: bold;
  }
}
</style>
